module.exports = __webpack_public_path__ + "static/img/ebms-title.ee813b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ebms-title.png
// module id = AMKx
// module chunks = 1